var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSave(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    "data-name": "Livello 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.63,9.65,33.76,1.48A4.88,4.88,0,0,0,31,.07V0H14.23A3.25,3.25,0,0,0,11,3.24V28.75A3.25,3.25,0,0,0,14.23,32H39.74A3.26,3.26,0,0,0,43,28.75V13A4.83,4.83,0,0,0,41.63,9.65ZM29.07,1.88V7.72H18.44V1.88ZM18.44,30.12v-10a.21.21,0,0,1,.21-.22H35.32a.22.22,0,0,1,.22.22v10Zm22.67-1.37a1.37,1.37,0,0,1-1.37,1.37H37.42v-10a2.1,2.1,0,0,0-2.1-2.1H18.65a2.1,2.1,0,0,0-2.09,2.1v10H14.23a1.36,1.36,0,0,1-1.36-1.37V3.24a1.36,1.36,0,0,1,1.36-1.36h2.33v6A1.69,1.69,0,0,0,18.25,9.6h11A1.69,1.69,0,0,0,31,7.91V2a2.93,2.93,0,0,1,1.45.82L40.28,11A3,3,0,0,1,41.11,13Z",
    transform: "translate(-10.99)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.2d900f64.svg";
export { ForwardRef as ReactComponent };